var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3519)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.99992,
    cy: 7.99992,
    r: 6.66667,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.91675C6.75 5.22639 7.30964 4.66675 8 4.66675C8.69036 4.66675 9.25 5.22639 9.25 5.91675C9.25 6.37505 9.00336 6.77574 8.63558 6.99333C8.31869 7.18081 8 7.46522 8 7.83341V8.66675",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99992,
    cy: 10.6667,
    r: 0.666667,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.39c46f2f07ac0730984039086418a3d1.svg";
export { ForwardRef as ReactComponent };